import axios from '@/http/index';

const base = '';
// 获得登录加密密钥
export const getSign = (param) => axios.get(`${base}/erp/login/getSign`, param).then((res) => res.data);
// 判断erp是否已经登录状态
export const getLoginStatus = (param) => axios.get(`${base}/erp/login/getLoginStatus`, param).then((res) => res.data);
// 根据code获取token
export const verify4Pc = (param) => axios.get(`${base}/erp/login/verify4Pc`, param).then((res) => res.data);
// 根据code获取token
export const getAuthLink = (param) => axios.post(`${base}/erp/login/backend_get_auth_link`, param).then((res) => res.data);
// 获得erp登录rl域名前缀
export const getErpLoginUrl = (param) => axios.get(`${base}/urlApi/79B4DE7C/getErpLoginUrl`, param).then((res) => res.data);
